import type Lot from '@/types/Lot'

function createStripedPattern(baseColor: string): CanvasPattern | string {
  if (typeof document === 'undefined') {
    return baseColor
  }

  const canvas = document.createElement('canvas')
  canvas.width = 10
  canvas.height = 10
  const context = canvas.getContext('2d')
  if (!context) {
    return baseColor
  }

  context.fillStyle = baseColor
  context.fillRect(0, 0, canvas.width, canvas.height)
  context.strokeStyle = 'rgba(255, 255, 255, 0.6)'
  context.lineWidth = 3
  context.beginPath()
  context.moveTo(0, canvas.height)
  context.lineTo(canvas.width, 0)
  context.stroke()

  return context.createPattern(canvas, 'repeat') ?? baseColor
}

function getLotBarColor(lot: Lot, baseColor: string): CanvasPattern | string {
  return lot.isProvisional ? createStripedPattern(baseColor) : baseColor
}

export { getLotBarColor }
